import React from "react";
var __jsx = React.createElement;
import ReusableBtn from "@/pages/checkout/bnpl/common/components/ReusableBtn";
export function InfoScreen(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    text = _ref.text,
    text2 = _ref.text2,
    injectedContent = _ref.injectedContent,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    _ref$fullScreen = _ref.fullScreen,
    fullScreen = _ref$fullScreen === void 0 ? true : _ref$fullScreen;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(fullScreen ? "min-h-dvh" : "h-full mt-32 md:mt-40", " bg-white flex items-center justify-center p-4")
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-md flex md:items-center md:justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:bg-white  md:shadow-sm  md:border-gray-100 p-6 md:p-12 md:min-w-[560px] md:border-solid md:border-[1px] md:rounded-2xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center mb-6"
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "text-center mb-8"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-2xl md:text-3xl my-6 text-primary-new font-bold"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D]  text-sm md:text-[20px] py-3 leading-7"
  }, text), text2 && /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-sm md:text-[20px] py-3 leading-7"
  }, text2)), injectedContent && injectedContent, /*#__PURE__*/React.createElement("div", {
    className: "space-y-3 w-full"
  }, /*#__PURE__*/React.createElement(ReusableBtn, {
    label: primaryButton.label,
    onClick: primaryButton.onClick,
    variant: "custom",
    borderColor: "#0D0DB5",
    textColor: "#fff",
    bgColor: "#0D0DB5"
  }), secondaryButton && /*#__PURE__*/React.createElement(ReusableBtn, {
    label: secondaryButton.label,
    onClick: secondaryButton.onClick,
    variant: "custom",
    borderColor: "#0D0DB5",
    textColor: "#0D0DB5"
  })))));
}